import { TrackingProvider } from "@similarweb/tracking-provider";

export default TrackingProvider;
